import React from 'react';
import PropTypes from 'prop-types';
import {
	TitleHeader,
	HeaderBody,
	StyledLink,
	LinksContainer,
	SingleLinkContainer,
} from './style';
import { ContentTitle } from '../../utilities/styledComponents/ContentTitle';
import colors from '../../../config/colors.json';
import utils from '../../../services/utils';

const basePath = utils.basePath();

const CampaignHeader = ({ children }) => (
	<>
		<TitleHeader>
			<div className="row">
				<div className="col-12">
					<ContentTitle
						fontSize="28px"
						lineheight="42px"
						padding="0"
						color={colors.lightGreyMidias}
					> { children }
					</ContentTitle>
				</div>
			</div>
		</TitleHeader>
	</>
);

export const CampaignHeaderWithLinks = ({ children }) => (
	<TitleHeader
		backgroundColor="transparent"
		padding="0"
		margin="0 0 20px 0"
	>
		<HeaderBody>
			<ContentTitle
				fontSize="28px"
				lineheight="42px"
				fontWeight="500"
				padding="0"
				color={colors.lightGreyMidias}
				backgroundColor="transparent"
			>
				{ children }
			</ContentTitle>
			<LinksContainer>
				<SingleLinkContainer>
					<StyledLink exact activeClassName="is-active" to={`${basePath}/campanhas`}>Painel</StyledLink>
				</SingleLinkContainer>
				<SingleLinkContainer>
					<StyledLink activeClassName="is-active" to={`${basePath}/minhascampanhas`}>Minhas campanhas</StyledLink>
				</SingleLinkContainer>
				<SingleLinkContainer>
					<StyledLink activeClassName="is-active" to={`${basePath}/relatorios`}>Relatórios</StyledLink>
				</SingleLinkContainer>
				<SingleLinkContainer>
					<StyledLink exact activeClassName="is-active" to={`${basePath}/logo`}>Logo</StyledLink>
				</SingleLinkContainer>
			</LinksContainer>
		</HeaderBody>
	</TitleHeader>
	);

PropTypes.CampaignHeader = {
    children: PropTypes.string.isRequired,
};

PropTypes.CampaignHeaderWithLinks = {
    children: PropTypes.string.isRequired,
};

export default CampaignHeader;
